import type React from "react";

import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { EmptyState } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/GeoBreakdown/EmptyState";
import { GeoBreakdown } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/GeoBreakdown/GeoBreakdown";

export const GeoBreakdownWithErrorBoundary: React.FC = () => {
    return (
        <ErrorBoundaryWithLogging
            fallback={
                <Card
                    dataAutomation="geo-breakdown-card"
                    header={
                        <CardHeader
                            title={translate("si.company-analysis.geo-breakdown.card.title")}
                            infoTooltip={translate("si.company-analysis.geo-breakdown.card.tooltip")}
                        />
                    }
                    renderContent={() => <EmptyState />}
                />
            }
        >
            <GeoBreakdown />
        </ErrorBoundaryWithLogging>
    );
};
